export default {"src":"/_next/static/media/GooglePlay.5c3da64a.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};